import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getMyTaskList = async (body) => {
    try {
        body = body || {};
        body.companyId = getReduxCompany()?.companyId || 0;

        const response = await axiosApi.post(`/DigilinkzMyTask/GetDigilinkzMyTask`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getMyTaskList===>:", error);
    }
};

export const MyTaskService = {
    getMyTaskList
}